import { AppModule } from '@core/modules/app/app.module'
import { AuthService } from '@core/services/auth'
import { clearMdrLocalStorage } from '@core/modules/mdr/utils'

const AMSLogoutRoute = () => {
    AppModule.store.setKey('initialized', false)
    AppModule.store.setKey('isAuthenticated', false)
    clearMdrLocalStorage()
    AppModule.storage.removeItem('currentAccount').then(() => {
        AuthService.logout()
    })

    return null
}

export default AMSLogoutRoute
